import { render, staticRenderFns } from "./followDialog.vue?vue&type=template&id=435a7320&scoped=true"
import script from "./followDialog.vue?vue&type=script&lang=js"
export * from "./followDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435a7320",
  null
  
)

export default component.exports